











import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {AxiosError, AxiosResponse} from "axios";
import {User} from "@/types";
import UserAvatar from "@/components/user/_userAvatar.vue";

@Component({
    computed: {...mapGetters(["user"])},
    components: {UserAvatar},
})
export default class CommentInput extends Vue {
    @Prop() postId!: any;
    @Prop() parentId!: any;
    @Prop() editContent!: any;
    @Prop() commentId!: number;
    @Prop() parentName!: string;

    content: string = "";


    isPrivate: boolean = false;
    user!: User;

    mounted() {
        if (this.editContent) {
            this.content = this.editContent;
        }
    }

    checkLogin() {
        if (!this.user) {
            this.$modal.show('needLogin')
        }
    }

    //수정 , 작성
    sendComment() {
    
        if (!this.user) {
            this.$modal.show('needLogin')
        }
        else {
            if (!this.content ||  this.content === ' ') {
                this.$modal.show({
                    template: `<div class="modal-alert">
                <dl class="ma-header">
                    <dt> {{ $t('information') }}</dt>
                    <dd>
                        <button @click="$modal.hide('minChar')"><i class="uil uil-times"></i></button>
                    </dd>
                </dl>
                <div class="ma-content">
                    <h2> {{ $t('post.empty.text') }}</h2>
                    <div>
                        <button class="btn-default" style="width:100%" @click="$modal.hide('minChar')">{{ $t('yes') }}</button>
                    </div>
                </div>
            </div>`,
                }, {}, {
                    name: "minChar",
                    width: 380,
                    maxWidth: 380,
                    height: "auto",
                    class: "modal-area-type",
                    scrollable: true
                })
                return;
            }
            if (this.commentId) {
                const obj = {
                    comment_id: this.commentId,
                    post_id: this.postId,
                    content: this.content
                }
                this.$api.updateComment(obj)
                    .then((res: AxiosResponse) => {
                        this.$emit('updateComment', res)
                    })
                    .catch((err: AxiosError) => {
                    })
                    .finally(() => {
                        // this.$emit("editDone", true);
                    })


            }
            else {
                const obj = {
                    user_id: this.user.id,
                    type: "COMMENT",
                    parent_id: this.parentId,
                    post_id: this.postId,
                    content: this.content,
                    is_private: this.isPrivate
                }
                this.$api.sendComment(obj)
                    .then((res: AxiosResponse) => {

                        this.$emit('sendComment', res)
                    })
                    .catch((err: AxiosError) => {

                    })


                this.content = "";
                this.isPrivate = false;
            }

        }

    }


}
